<template>
    <v-card>
        <v-card-title> What are you looking for? </v-card-title>

        <v-card-text>
            <v-autocomplete
                :items="items"
                :loading="isLoading"
                :search-input.sync="search"
                hide-no-data
                item-text="name"
                item-value="id"
                label="Search..."
                prepend-icon="mdi-search"
                no-data-text="No Items Found"
                :menu-props="{ 'max-width': '1000px' }"
                no-filter
            >
                <template v-slot:item="{ item }">
                    <v-list-item
                        @click.stop="
                            $inertia.get(
                                route('catalogue.product', {
                                    department:
                                        item.product_group.department.slug,
                                    productGroup: item.product_group.slug,
                                    product: item.slug,
                                })
                            )
                        "
                    >
                        <v-list-item-avatar tile size="60">
                            <v-img eager :src="item.thumb_url" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title v-text="item.name" />
                            <v-list-item-subtitle
                                style="
                                    width: 100%;
                                    max-width: 100%;
                                    min-width: 100%;
                                "
                                v-text="item.description"
                            />
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-autocomplete>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "ProductSearch",

    data() {
        return {
            search: "",
            items: [],
            isLoading: false,
        };
    },

    watch: {
        search() {
            this.getProducts();
        },
    },

    methods: {
        getProducts: window._.debounce(function () {
            this.isLoading = true;

            if (!this.search) {
                this.items = [];
                this.isLoading = false;
                return;
            }

            window.axios
                .get(this.route("catalogue.search", { search: this.search }))
                .then((response) => {
                    this.items = response.data;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }, 500),
    },
};
</script>

<style scoped></style>
